import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Dewey } from '../../../models/Dewey';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-dewey-selector',
  templateUrl: './dewey-selector.component.html',
  styleUrls: ['./dewey-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DeweySelectorComponent),
      multi: true
    }
  ]
})
export class DeweySelectorComponent implements OnInit, ControlValueAccessor {
  items: Observable<any>;
  selected: Dewey;
  loading: boolean;
  // deweyCtrl: FormControl;
  // deweyCtrl = new FormControl('', [Validators.required]);

  @Input() livello: string;
  @Input() placeholder: string;
  @Output() notify: EventEmitter<Dewey> = new EventEmitter<Dewey>();

  constructor(private bookService: BookService) {

  }

  onChange(e: Dewey) {
    this.notify.emit(e);
    this.propagateChange(e);
  }

  set _count(c: number) {
    // console.log('_count', c)
  }

  ngOnInit() {  }

  compareWithFn(o1: Dewey, o2: Dewey) {
    return o1 && o2 ?
    (o1.liv01 == o2.liv01 && o1.liv02 == o2.liv02 && o1.liv03 == o2.liv03 && o1.liv04 == o2.liv04) : false;
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Dewey) {
    let q = {
      liv: +this.livello,
      liv01: obj ? obj.liv01 : '',
      liv02: obj ? obj.liv02 : '',
      liv03: obj ? obj.liv03 : '',
      liv04: obj ? obj.liv04 : ''
    }
    //  console.log('======= ************ writeValue', this.livello, obj, q)
    this.loading = true;

    this.items = this.bookService.readDewey(q)
      .map(result => {
        this.loading = false;
        if (result.success) {
          if (obj) {
            let pname = 'liv0' + this.livello;
            this.selected = result.items.find(p => p[pname] == obj[pname]);
          }
          this.propagateChange(this.selected);
          return result.items;
        }
      })
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/book/dewey-selector/dewey-selector.component.ts